import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/solid";
import { useTheme } from "@mui/material";
import cn from "classnames";
import React from "react";
import { BiLoaderAlt } from "react-icons/bi";
import TokenSelection from "../TokenSelection/TokenSelection";

const SendCard = ({
  cardName,
  cardStyle,
  isInsufficientBalance,
  connectedAccount,
  paletteMode,
  dropdownRef1,
  setIsOpen,
  isOpen,
  selectedToken,
  tokens,
  swapTokens,
  handleTokenChange,
  getFormattedBalance,
  newOnChangeSwapInputs,
  selectedToken2,
  formatBalanceForPrice,
  safeParseNumber,
  sendValue,
  pricemap,
  newMax,
  loading,
  approve,
  setLoading,
  swap,
  isSwapping,
  swapConfirmModal,
  newCheck,
  isIncreaseBalance,
}) => {
  return (
    <article
      className={
        "border border-deepBlue rounded-lg flex-row items-center pt-4 pb-6 z-20 w-full"
      }
    >
      <div className="w-full">
        {/* "Send" Label */}
        <div
          className={`px-6 pb-4 md:px-8 border-b ${
            paletteMode === "light"
              ? "border-lightBlue"
              : "border-darkSlateBlue"
          } dark:border-darkSlateBlue `}
        >
          <div className="flex justify-between items-center mb-3">
            <h3
              className={
                "leading-6 text-base font-medium text-black dark:text-white"
              }
            >
              {cardName}
            </h3>
            {isInsufficientBalance && connectedAccount && (
              <div className="flex justify-between gap-1">
                <p className="text-fadedRed text-sm">Insufficient Balance.</p>
                {!isIncreaseBalance && (
                  <button
                    type="button"
                    className={cn("text-fadedRed text-sm")}
                    onClick={() => {
                      if (!loading && approve) {
                        setLoading(true);
                        swap()
                          .then(() => {
                            setLoading(false);
                          })
                          .catch(() => {
                            setLoading(false);
                          });
                      }
                    }}
                    disabled={!approve || isSwapping}
                  >
                    {swapConfirmModal ? (
                      <span className="flex gap-1 flex-row items-center">
                        <img
                          alt="NewCheck"
                          src={newCheck}
                          className="w-4 h-4 mr-2 mt-[2px] rounded-[12px]"
                        />
                        Swapped
                      </span>
                    ) : isSwapping ? (
                      <div>
                        <BiLoaderAlt className="animate-spin text-gray-50" />
                      </div>
                    ) : (
                      <span className="underline cursor-pointer">Swap Now</span>
                    )}
                  </button>
                )}
              </div>
            )}
          </div>

          {/* Token selection and input */}
          <TokenSelection
            tokens={tokens}
            dropdownRef1={dropdownRef1}
            setIsOpen={setIsOpen}
            isOpen={isOpen}
            paletteMode={paletteMode}
            selectedToken={selectedToken}
            ChevronUpIcon={ChevronUpIcon}
            ChevronDownIcon={ChevronDownIcon}
            swapTokens={swapTokens}
            handleTokenChange={handleTokenChange}
            selectedToken2={selectedToken2}
            newMax={newMax}
            sendValue={sendValue}
            newOnChangeSwapInputs={newOnChangeSwapInputs}
            isSendCard={true}
            swapTokenValue={1}
            isIncreaseBalance={isIncreaseBalance}
          />
        </div>

        <div className="w-full px-6 md:px-8 pt-3 flex flex-col gap-1 md:flex-row md:justify-between md:gap-0">
          {/* Token Balance */}

          <div className={"flex items-center gap-2 items-center"}>
            <p
              className={` text-xs 
            ${
              paletteMode === "light" ? "text-semiBlack" : "text-semiWhite"
            }  md:text-sm leading-[14.4px] md:leading-4 dark:text-semiWhite`}
            >
              Balance
            </p>
            <span className="flex-1 bg-lightGrayBlue h-[1px]  dark:bg-darkSlateBlue md:hidden" />
            <p
              className={` text-xs  md:text-sm leading-6 ${
                paletteMode === "light" ? "text-black" : "text-white"
              } dark:text-white`}
            >{`${
              getFormattedBalance(selectedToken.name) === "0"
                ? "00.00"
                : getFormattedBalance(selectedToken.name)
            } ${selectedToken.name}`}</p>
          </div>

          <p
            className={`${
              paletteMode === "light" ? "text-semiBlack" : "text-semiWhite"
            }  text-xs  md:text-sm 
              leading-[14.4px] md:leading-4 flex items-center gap-2 dark:text-semiWhite`}
          >
            <p>Amount in USD</p>
            <span className="flex-1 bg-lightGrayBlue h-[1px]  dark:bg-darkSlateBlue md:hidden" />
            <p
              className={`${
                paletteMode === "light" ? "text-black" : "text-white"
              } text-xs  md:text-sm leading-6 dark:text-white`}
            >
              ≈
              {formatBalanceForPrice(
                safeParseNumber(sendValue) *
                  safeParseNumber(pricemap[selectedToken.name])
              ) === "0"
                ? "00.00"
                : formatBalanceForPrice(
                    safeParseNumber(sendValue) *
                      safeParseNumber(pricemap[selectedToken.name])
                  )}
              $
            </p>
          </p>
        </div>
      </div>
    </article>
  );
};

export default SendCard;
